import AuthService from "@/services/AuthService";
import * as PERMISSIONS from "@/models/permissions";

// Global permissions service
class PermissionsService {
  constructor() {
    this.UsersPermissionsService = new UsersPermissionsService();
    this.RolesPermissionsService = new RolesPermissionsService();
    this.PreferencesPermissionsService = new PreferencesPermissionsService();
    this.FederationsPermissionsService = new FederationsPermissionsService();
    this.DisciplinesPermissionsService = new DisciplinesPermissionsService();
    this.TeamsPermissionsService = new TeamsPermissionsService();
    this.AthletesPermissionsService = new AthletesPermissionsService();
    this.ExercisesPermissionsService = new ExercisesPermissionsService();
    this.CyclesPermissionsService = new CyclesPermissionsService();
    this.MediasPermissionsService = new MediasPermissionsService();
  }
}

// Users permissions service
class UsersPermissionsService {
  // Can View All Users Permission
  get canViewAllUsers() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_USERS) : null;
    return permission ? true : false;
  }

  // Can Manage All Users Permission
  get canManageAllUsers() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_USERS) : null;
    return permission ? true : false;
  }
}

// Roles permissions service
class RolesPermissionsService {
  // Can View All Roles Permission
  get canViewAllRoles() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_ROLES) : null;
    return permission ? true : false;
  }

  // Can Manage All Roles Permission
  get canManageAllRoles() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_ROLES) : null;
    return permission ? true : false;
  }
}

// Preferences permissions service
class PreferencesPermissionsService {
  // Can View Preferences Permission
  get canViewPreferences() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_PREFERENCES) : null;
    return permission ? true : false;
  }

  // Can Manage Preferences Permission
  get canManagePreferences() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_PREFERENCES) : null;
    return permission ? true : false;
  }
}

// Federations permissions service
class FederationsPermissionsService {
  // Can View All Federations Permission
  get canViewAllFederations() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_FEDERATIONS) : null;
    return permission ? true : false;
  }

  // Can Manage All Federations Permission
  get canManageAllFederations() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_FEDERATIONS) : null;
    return permission ? true : false;
  }

  // Can View Own Federation Permission
  get canViewOwnFederation() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_OWN_FEDERATION) : null;
    return permission ? true : false;
  }

  // Can Manage Own Federation Permission
  get canManageOwnFederation() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_OWN_FEDERATION) : null;
    return permission ? true : false;
  }
}

// Disciplines permissions service
class DisciplinesPermissionsService {
  // Can View All Disciplines Own Federation Permission
  get canViewAllDisciplinesOwnFederation() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_DISCIPLINES_OWN_FEDERATION) : null;
    return permission ? true : false;
  }

  // Can Manage All Disciplines Own Federation Permission
  get canManageAllDisciplinesOwnFederation() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_DISCIPLINES_OWN_FEDERATION) : null;
    return permission ? true : false;
  }

  // Can View Own Discipline Permission
  get canViewOwnDiscipline() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_OWN_DISCIPLINE) : null;
    return permission ? true : false;
  }

  // Can Manage Own Discipline Permission
  get canManageOwnDiscipline() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_OWN_DISCIPLINE) : null;
    return permission ? true : false;
  }
}

// Teams permissions service
class TeamsPermissionsService {
  // Can View All Teams Own Discipline Permission
  get canViewAllTeamsOwnDiscipline() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_TEAMS_OWN_DISCIPLINE) : null;
    return permission ? true : false;
  }

  // Can Manage All Teams Own Discipline Permission
  get canManageAllTeamsOwnDiscipline() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_TEAMS_OWN_DISCIPLINE) : null;
    return permission ? true : false;
  }

  // Can View Own Team Permission
  get canViewOwnTeam() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_OWN_TEAM) : null;
    return permission ? true : false;
  }

  // Can Manage Own Team Permission
  get canManageOwnTeam() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_OWN_TEAM) : null;
    return permission ? true : false;
  }
}

// Athletes permissions service
class AthletesPermissionsService {
  // Can View Own Coach Athletes Permission
  get canViewOwnCoachAthletes() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ATHLETES_OWN_COACH) : null;
    return permission ? true : false;
  }

  // Can Manage Own Coach Athletes Permission
  get canManageOwnCoachAthletes() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ATHLETES_OWN_COACH) : null;
    return permission ? true : false;
  }
}

// Exercises permissions service
class ExercisesPermissionsService {
  // Can View All Exercises Permission
  get canViewAllExercises() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_EXERCISES) : null;
    return permission ? true : false;
  }

  // Can Manage All Exercises Permission
  get canManageAllExercises() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_EXERCISES) : null;
    return permission ? true : false;
  }

  // Can View Own Exercises Permission
  get canViewOwnExercises() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_OWN_EXERCISES) : null;
    return permission ? true : false;
  }

  // Can Manage Own Exercises Permission
  get canManageOwnExercises() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_OWN_EXERCISES) : null;
    return permission ? true : false;
  }
}

// Cycles permissions service
class CyclesPermissionsService {
  // Can View All Cycles Permission
  get canViewAllCycles() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_CYCLES) : null;
    return permission ? true : false;
  }

  // Can Manage All Cycles Permission
  get canManageAllCycles() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_CYCLES) : null;
    return permission ? true : false;
  }

  // Can View Own Cycles Permission
  get canViewOwnCycles() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_OWN_CYCLES) : null;
    return permission ? true : false;
  }

  // Can Manage Own Cycles Permission
  get canManageOwnCycles() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_OWN_CYCLES) : null;
    return permission ? true : false;
  }
}

// Medias permissions service
class MediasPermissionsService {
  // Can View All Medias Permission
  get canViewAllMedias() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_ALL_MEDIAS) : null;
    return permission ? true : false;
  }

  // Can Manage All Medias Permission
  get canManageAllMedias() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_ALL_MEDIAS) : null;
    return permission ? true : false;
  }

  // Can View Own Medias Permission
  get canViewOwnMedias() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.VIEW_OWN_MEDIAS) : null;
    return permission ? true : false;
  }

  // Can Manage Own Medias Permission
  get canManageOwnMedias() {
    let permission = AuthService && AuthService.permissions ? AuthService.permissions.find((p) => p == PERMISSIONS.MANAGE_OWN_MEDIAS) : null;
    return permission ? true : false;
  }
}

export default new PermissionsService();
